export const HAS_REVIEWS = {
    NO: 'NO',
    HOST: 'HOST',
    GUEST: 'GUEST',
    BOTH: 'BOTH',
};

export const USER_TEST_GROUP = {
    ONE_PAGE_CHECKOUT: 'frontOnePageCheckout',
    APP_REQUIRED_SNIFFPASS: 'appRequiredSniffpass',
    GLOBAL_REQUIRED_SNIFFPASS: 'globalRequiredSniffpass',
    FRONT_NON_AUTH_REVIEW_V2: 'frontNonAuthReviewV2',
    FRONT_RECENT_REVIEWS: 'frontRecentReviews',
    FRONT_ADD_SPOT_PHOTO_REMINDER: 'frontAddSpotPhotoReminder',
    FRONT_ADD_SPOT_REQ_PHOTO: 'frontAddSpotReqPhotoV7480',
    FRONT_REVISE_HOME: 'frontReviseHomepage',
    BACK_NASCENT_STATE_CROSS: 'backNascentStateCross',
};

export const SIGN_UP_SRC = {
    ACCOUNT_WEB: 'ACCOUNT_WEB',
    AD_POPUP_WEB: 'AD_POPUP_WEB', // Ad popup
    ADD_PEOPLE_WEB: 'ADD_PEOPLE_WEB',
    BOTTOM_SEARCH_WEB: 'BOTTOM_SEARCH_WEB', // Bottom search
    CALENDAR_WEB: 'CALENDAR_WEB', // Calendar
    CHAT_WEB: 'CHAT_WEB',
    CHECKOUT_WEB: 'CHECKOUT_WEB', // Checkout
    CITY_DOG_PARK_WEB: 'CITY_DOG_PARK_WEB',
    DOGTRAINERS_WEB: 'DOGTRAINERS_WEB',
    DOGRESCUES_WEB: 'DOGRESCUES_WEB',
    FAVORITE_SEARCH_WEB: 'FAVORITE_SEARCH_WEB', // Favorite search
    FAVORITE_SPOT_WEB: 'FAVORITE_SPOT_WEB', // Favorite spot
    FILTERS_WEB: 'FILTERS_WEB',
    HOME_FORM_WEB: 'HOME_WEB',
    HOST_BANNER_WEB: 'HOST_BANNER_WEB', // Host banner
    HOST_CTA_WEB: 'HOST_CTA_WEB', // Host CTA
    HOST_FLOATING_CTA_WEB: 'HOST_FLOATING_CTA_WEB',
    HOST_LANDING_SHORT_WEB: 'HOST_LANDING_SHORT_WEB',
    INVITE_WEB: 'INVITE_WEB', // Invite
    MEMBERSHIPS_WEB: 'MEMBERSHIPS_WEB',
    MEMBERSHIP_LANDING_WEB: 'MEMBERSHIP_LANDING_WEB',
    MESSAGE_HOST_WEB: 'MESSAGE_HOST_WEB', // Message host
    NAV_WEB: 'NAVMENU_WEB', // Nav menu
    NEWHEADER_WEB: 'NEWHEADER_WEB', // New mobile top bar
    PHOTO_CAROUSEL_WEB: 'PHOTO_CAROUSEL_WEB',
    PLAYMATES_WEB: 'PLAYMATES_WEB',
    PLAYMATES_SEO_WEB: 'PLAYMATES_SEO_WEB',
    PHOTO_REQUEST_WEB: 'PHOTO_REQUEST_WEB', // Photo request
    REPORT_WEB: 'REPORT_WEB', // Report
    REVIEW_WEB: 'REVIEW_WEB',
    SEARCHPOPUP_WEB: 'SEARCHPOPUP_WEB',
    SEOPOPUP_SPOT_ALERT_WEB: 'SEOPOPUP_SPOT_ALERT_WEB',
    SEOPOPUP_WEB: 'SEOPOPUP_WEB',
    SNIFFPASS_WEB: 'SNIFFPASS_WEB',
    SNIFFPASS_HOME_WEB: 'SNIFFPASS_HOME_WEB',
    SPOT_DETAIL_SCROLL_WEB: 'SPOT_DETAIL_SCROLL_WEB',
    SPOT_DETAILS_WEB: 'SPOT_DETAILS_WEB',
    VISIT_WEB: 'VISIT_WEB',
};
